import { getScopeActions } from './scopeActionMap';
import { createScopedDispatchers } from '../../shared/selectHandlers/createScopedDispatchers';

export const selectLocationDispatchHandler = (
  dispatch, scope, name, locationList, specificLocationList, machineList,
  newSelectedLocations, newSpecificLocations, newMachines
) => {
  const { selectLocationDispatch } = createScopedDispatchers(getScopeActions(scope), 'controller');
  selectLocationDispatch(dispatch, name, locationList, specificLocationList, machineList, newSelectedLocations, newSpecificLocations, newMachines);
};
